<template>
  <div class="visualization-controls__select">
    <label for="age">Age:</label>
    <multiselect
      :options="ageOptions"
      :multiple="true"
      track-by="value"
      label="name"
      :close-on-select="true"
      :clear-on-select="true"
      :preserve-search="false"
      :show-labels="false"
      :value="ageSelections"
      @input="setAgeSelection"
    />
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import Multiselect from "vue-multiselect";

export default {
  components: {
    Multiselect,
  },

  computed: {
    ageOptions() {
      return [
        { name: "Adult", value: "A" },
        { name: "Yearling", value: "Y" },
        { name: "Fawn", value: "F" },
      ];
    },
    ageSelections() {
      return this.$store.state.visualization.ageSelections;
    },
  },

  methods: {
    ...mapMutations({
      setAges: "visualization/setAges",
      setAgeSelections: "visualization/setAgeSelections",
    }),
    setAgeSelection(ages) {
      this.setAgeSelections(ages);
      this.$emit("child-changed");
    },
  },
};
</script>

<style lang="scss" scoped></style>
